export default __webpack_public_path__ + "static/media/video_unavailable.8ae4a783.jpg";